import { Layout } from './Layout';
import { LoginComponent } from './LoginComponent';
import { ServerStatus } from './ServerStatus';

function Component() {
  return (
    <Layout>
      <LoginComponent />
      {/* <ServerStatus /> */}
    </Layout>
  );
}

export const LoginPage = Component;
